import fetch from "../fetch";

export default ({ saleId, propertyId, values }) =>
  fetch({
    path: `/re/sales/${saleId}/props/${propertyId}/portfolios`,
    method: "PUT",
    data: values
  });
